import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useCallback } from "react";
import { useStoreSystem } from "../../../store";
import shallow from 'zustand/shallow';



export function LoadProjectModal() {
    const { projectModalIsOpen, setSystemProperties, forceLoadProject } = useStoreSystem(state => ({
        projectModalIsOpen: state.projectModal.isOpen,
        setSystemProperties: state.setSystemProperties,
        forceLoadProject: state.forceLoadProject,
    }), shallow);

    const handleClose = useCallback(() => {
        setSystemProperties([{ name: 'projectModal', subName: 'isOpen', value: false }]);
    }, [])

    const onLoadHandler = useCallback(() => {
        forceLoadProject()
        setSystemProperties([{ name: 'projectModal', subName: 'isOpen', value: false }]);
    }, [forceLoadProject]);

    return (
        <Dialog
            open={projectModalIsOpen}
            onClose={handleClose}
        >
            <DialogTitle>
                {"Загрузить проект?"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Локальный и загружаемый проекты разные, изменения в локальном проекте будут перезаписаны.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant={'outlined'} onClick={onLoadHandler} >
                    Загрузить
                </Button>
                <Button variant={'contained'} onClick={handleClose}>Отмена</Button>
            </DialogActions>
        </Dialog>
    );
}